module.exports = __webpack_public_path__ + "img/dunaint3.63114c8c.png";